export const spaceTemplateCookie = 'spaceTemplateUsed';
